export default "__VITE_ASSET__CArRJJvw__"